// VoiceSpectrum T2 - lib/smsText - v12.9.13 (#801)
//
// The three pure functions behind the Send Text composer, lifted out of MessagesPage so they can be TESTED.
//
// WHY THEY MOVED. 12.9.12 shipped all three with no tests, against a rule Tushar set on 2026-08-31 after
// v12.3.12 shipped a crash: "if a defect can be reduced to a function that takes values and returns a value,
// the fix is not finished until a test pins it." I only noticed because the build printed total: 1701 - the
// exact same total as 12.9.11, which is the arithmetic proof that I added none.
//
// HIS DECISION, 2026-09-27, asked directly rather than guessed: move them somewhere the EXISTING .NET Unit
// project can reach, rather than standing up a second test runner in the pipeline for three functions.
//
// SO THE RULES NOW LIVE IN VoiceSpectrum.Shared/Messaging/SmsText.cs AND THIS FILE MUST AGREE WITH IT.
// Two copies of a rule with a comment asking a human to keep them in step is exactly what #412 was - the
// interceptor's phrases lived twice, the T2 copy carried a "KEEP IN STEP WITH..." comment and was, in the
// same commit, not in step. A comment is not a mechanism. The mechanism is tools/Check-SmsTextParity.mjs,
// which runs THIS file against the C# test file's own cases and fails the build when they disagree.
//
// The browser still needs them here: the character count updates as the agent types, which no server call
// can do. That is why this is a mirror and not a deletion.

/** The national digits of a number, with a US country code stripped. +1 only - see #800 for the rest. */
export function nationalDigits(phone: string): string {
  const d = (phone ?? '').replace(/\D/g, '');
  return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
}

/**
 * How many texts this message will actually send as.
 *
 * GSM-7 holds 160 characters in ONE segment. A longer message is CONCATENATED and the per-segment budget
 * drops to 153, because each part carries a header saying which part it is - which is why 320 characters is
 * THREE texts and not two. Anyone "simplifying" this to Math.ceil(n / 160) breaks it silently and the UI
 * still looks right; that is precisely what the tests exist to catch.
 *
 * It warns, it never blocks: the agent is told what will happen and decides.
 */
export function smsSegments(text: string): number {
  const n = (text ?? '').length;
  if (n === 0) return 1;
  return n <= 160 ? 1 : Math.ceil(n / 153);
}

/** Merge fields in a template body. EVERY occurrence, not just the first - hence the global flags. */
export function fillTemplate(body: string, name: string, practice: string, date: string): string {
  return (body ?? '')
    .replace(/\{name\}/g, name ?? '')
    .replace(/\{practice\}/g, practice ?? '')
    .replace(/\{date\}/g, date ?? '');
}
